var exports = {
  "k": "x804f0401--ca46ce--container",
};

module.exports = exports;
